const dBType: any = process.env[`OMS_DB_TYPE`] || 'mysql';
const keyCloackDbType: any = String(process.env[`NX_KEYCLOAK_DB_TYPE`]) || 'mysql';
const kafkaBrokers:string[]=[process.env[`KAFKA_BROKER`]];
export const wmsConfigs = {
  port: parseInt(process.env[`WMS_SERVER_PORT`]) || 3337,
  database: {
    type: dBType,
    host: process.env[`WMS_DB_HOST`],
    port: parseInt(process.env[`WMS_DB_PORT`]) || 3306,
    username: process.env[`WMS_DB_USER`] || 'ramakrishna',
    password: process.env[`WMS_DB_PASS`] || 'R@ms1905',
    dbName: process.env[`WMS_DB_DBNAME`] || 'erpx',
  },
  loggingMode: process.env[`WMS_LOGGING_MODE`] || 'error',
  sync: process.env[`WMS_DB_SYNC`] == 'true' ? true : false,
  keycloak: {
    keycloakUrl: process.env[`NX_KEYCLOAK_AUTH_URL`],
    keycloakRealm: process.env[`NX_KEYCLOAK_REALM`],
    keycloakClientId: process.env[`NX_WMS_KC_CLIENT`] || 'WMS-back-end',
    keycloakSecretKey: process.env[`NX_WMS_KC_SECRET`],
    keycloakDB: process.env[`NX_KEYCLOAK_DB`] || 'keycloak',
    keycloakDBType: keyCloackDbType,
    keycloakDBHost: process.env[`NX_KEYCLOAK_DB_HOST`],
    keycloakDBPort: parseInt(process.env[`NX_KEYCLOAK_DB_PORT`]),
    keycloakDBUser: process.env[`NX_KEYCLOAK_DB_USER`],
    keycloakDBPass: process.env[`NX_KEYCLOAK_DB_PASS`],
  },
  redisBullJs: {
    host: process.env[`REDIS_HOST`],
    port: parseInt(process.env[`REDIS_PORT`]),
    password: process.env[`REDIS_PASSWORD`],
  },
  kafka: {
    clientId:process.env[`KAFKA_CLIENT_ID`],
    groupId:process.env[`KAFKA_GROUP_ID`],
    brokers:kafkaBrokers,
  },
  externalApis: {
    pixel: {
      temperatureRetrievalApi: 'https://pixelapi.adaptideations.com/api/devicePings',
      integrationApiIntervalMinutes: 2
    }
  }
}

export default wmsConfigs;